import { NewClient } from 'common'

export interface ClientIntervalDetails {
  value: NewClient.interval
  label: string
  pricingLabel: string
  description: string
  icon: string
  months: number
}

export const CLIENT_INTERVAL_OPTIONS: ClientIntervalDetails[] = [
  {
    value: NewClient.interval.MONTH,
    label: 'Monthly',
    pricingLabel: 'monthly',
    description: 'Billed every month',
    icon: 'calendar_month',
    months: 1
  },
  {
    value: NewClient.interval.QUARTER,
    label: 'Quarterly',
    pricingLabel: 'quarterly',
    description: 'Every 3 months',
    icon: 'date_range',
    months: 3
  },
  {
    value: NewClient.interval.SEMI_ANNUAL,
    label: 'Bi-Annual',
    pricingLabel: 'biannually',
    description: 'Every 6 months',
    icon: 'event_repeat',
    months: 6
  },
  {
    value: NewClient.interval.YEAR,
    label: 'Annual',
    pricingLabel: 'annually',
    description: 'Billed once a year',
    icon: 'calendar_today',
    months: 12
  }
]

const CLIENT_INTERVAL_DETAILS = Object.fromEntries(
  CLIENT_INTERVAL_OPTIONS.map((option) => [option.value, option])
) as Record<NewClient.interval, ClientIntervalDetails>

export const clientIntervalDetails = (interval: NewClient.interval): ClientIntervalDetails =>
  CLIENT_INTERVAL_DETAILS[interval]
